import React from "react";
import styles from "./index.module.scss";
import { Button, Checkbox } from "antd";

interface NoticeToolBarProps {
    unreadNum: number;
    viewUnread(e: any): void;
    markReadAll(): void;
    clearReadAll(): void;
}

export function NoticeToolBar({
    viewUnread,
    unreadNum,
    markReadAll,
    clearReadAll
}: NoticeToolBarProps) {
    return (
        <div className={styles.root}>
            <Checkbox onChange={viewUnread}>
                仅查看未读消息
                <span style={{ color: "#FF2E3E" }}>（{unreadNum}）</span>
            </Checkbox>

            <div className={styles.button}>
                <Button type="link" onClick={markReadAll}>
                    全部标记已读
                </Button>

                <Button type="link" onClick={clearReadAll}>
                    清空已读
                </Button>
            </div>
        </div>
    );
}
